module.exports = __webpack_public_path__ + "static/media/px2.0fddc270.png";